import { render, staticRenderFns } from "./StrategyCollectionBreadcrumb.vue?vue&type=template&id=dd6a803c&scoped=true"
import script from "./StrategyCollectionBreadcrumb.vue?vue&type=script&lang=js"
export * from "./StrategyCollectionBreadcrumb.vue?vue&type=script&lang=js"
import style0 from "./StrategyCollectionBreadcrumb.vue?vue&type=style&index=0&id=dd6a803c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6a803c",
  null
  
)

export default component.exports